// jshint esversion: 6

export default {
  drawer: null,
  color: 'success',
  image: 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg',
  loading: false,
  progress: 0,
  notifications: [],
  error: [],
  tokenExpire: null
};
